import { createSlice } from "@reduxjs/toolkit";
import { getCrmCustomer, addCrmCustomer, updateCrmCustomer, deleteCrmCustomer, exportCrmCustomers } from './thunk';

export const initialState: any = {
    customerLists: [],
    totalCustomers: 0,
    error: {},
    isLoading: false,
};

const CustomerSlice = createSlice({
    name: 'CustomerSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        //Get Customers
        builder.addCase(getCrmCustomer.pending, (state: any, action: any) => {
            state.isLoading = true;
        });
        builder.addCase(getCrmCustomer.fulfilled, (state: any, action: any) => {
            state.isLoading = false;
            state.customerLists = action.payload.data;
            state.totalCustomers = action.payload.meta.total;
        });
        builder.addCase(getCrmCustomer.rejected, (state: any, action: any) => {
            state.isLoading = false;
            state.error = action.payload.error || null;
        });

        //Add Customer
        builder.addCase(addCrmCustomer.pending, (state: any) => {
            state.isLoading = true;
        });
        builder.addCase(addCrmCustomer.fulfilled, (state: any, action: any) => {
            state.isLoading = false;
            state.customerLists = [...state.customerLists, action.payload.data ? action.payload.data : action.payload];
        });

        builder.addCase(addCrmCustomer.rejected, (state: any, action: any) => {
            state.isLoading = false;
            state.error = action.payload?.error || action.payload || null;
        });
        
        //UpdateCustomer
        builder.addCase(updateCrmCustomer.pending, (state: any) => {
            state.isLoading = true;
        });
        builder.addCase(updateCrmCustomer.fulfilled, (state: any, action: any) => {
            state.isLoading = false;
            state.customerLists = state.customerLists.map((customer: any) =>
                customer.id === action.meta.arg.id
                    ? {...customer, ...action.meta.arg}
                    : customer
            );
        });

        builder.addCase(updateCrmCustomer.rejected, (state: any, action: any) => {
            state.isLoading = false;
            state.error = action.payload?.error || action.payload || null;
        });

        //Delete Customer
        builder.addCase(deleteCrmCustomer.pending, (state: any) => {
            state.isLoading = true;
        });
        builder.addCase(deleteCrmCustomer.fulfilled, (state: any, action: any) => {
            state.isLoading = false;
            state.customerLists = (state.customerLists || []).filter((product: any) => product.id !== action.payload.id);
        });
        builder.addCase(deleteCrmCustomer.rejected, (state: any, action: any) => {
            state.isLoading = false;
            state.error = action.payload?.error || action.payload || null;
        });

        //Export Customer
        builder.addCase(exportCrmCustomers.fulfilled, (state: any, action: any) => {
            state.isLoading = false;
        });
        builder.addCase(exportCrmCustomers.rejected, (state: any, action: any) => {
            state.isLoading = false;
            state.error = action.payload.error || null;
        });
        builder.addCase(exportCrmCustomers.pending, (state: any, action: any) => {
            state.isLoading = true;
        });

    }
});

export default CustomerSlice.reducer;
